import { render, staticRenderFns } from "./configuracion.vue?vue&type=template&id=523a0d0a&scoped=true&"
import script from "./configuracion.vue?vue&type=script&lang=js&"
export * from "./configuracion.vue?vue&type=script&lang=js&"
import style0 from "./configuracion.vue?vue&type=style&index=0&id=523a0d0a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "523a0d0a",
  null
  
)

export default component.exports